import { createAction } from 'redux-actions';
import { SET_STATUS_TOGGLE } from '../constants/actionTypes';
export const setStatusToggle = createAction(SET_STATUS_TOGGLE, statusToggle => ({
  statusToggle
}));